// import React, { useEffect, useRef } from 'react';
// import * as THREE from 'three';

// const ASTEROID_COLORS = [0x6b6761, 0x77716a, 0x827b72, 0x91877b, 0x5f5c57, 0x756b61];

// export default function AsteroidBelt3D({
//   geometries = [],       // [{ key, geometry }] from normalizeAndSplitAssets
//   innerR,
//   outerR,
//   sunOffsetX = 0,
//   sunOffsetY = 0,
//   containerSize,         // { width, height }
//   count = 10,
//   visible = true,
// }) {
//   const canvasRef = useRef(null);
//   const rendererStateRef = useRef({});
//   const sizeRef = useRef(containerSize);
//   sizeRef.current = containerSize;

//   // Build the scene once (when geometries first arrive). Resizing is
//   // handled separately below so we don't rebuild 250 instances on every
//   // window resize.
//   useEffect(() => {
//     if (!geometries.length) return;
//     const canvas = canvasRef.current;
//     const { width, height } = sizeRef.current;
//     if (!width || !height) return;

//     const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
//     renderer.setPixelRatio(Math.min(window.devicePixelRatio, 3));
//     renderer.setSize(width, height, false);

//     const scene = new THREE.Scene();

//     // Same pixel-space coordinate system as your SVG viewBox
//     // (`-w/2 -h/2 w h`), looking straight down. Rotational symmetry of a
//     // belt means we don't need to match the SVG's y-flip convention.
//     const camera = new THREE.OrthographicCamera(
//       -width / 2, width / 2, height / 2, -height / 2, 0.1, 2000
//     );
//     camera.position.set(0, 0, 500);
//     camera.lookAt(0, 0, 0);

//     scene.add(new THREE.AmbientLight(0xffffff, 0.45));
//     const keyLight = new THREE.DirectionalLight(0xfff2d9, 1.1);
//     keyLight.position.set(-300, 400, 600); // off-axis so flat-shaded facets actually show contrast
//     scene.add(keyLight);

//     const group = new THREE.Group();
//     const perGeomCount = Math.max(1, Math.round(count / geometries.length));
//     const dummy = new THREE.Object3D();
//     const records = []; // per-instance state, for the slow-rotation animation loop

//     geometries.forEach(({ geometry }, gi) => {
//       const material = new THREE.MeshStandardMaterial({
//         color: ASTEROID_COLORS[gi % ASTEROID_COLORS.length],
//         flatShading: true,
//         roughness: 1,
//         metalness: 0,
//       });

//       const instanced = new THREE.InstancedMesh(geometry, material, perGeomCount);
//       instanced.instanceMatrix.setUsage(THREE.DynamicDrawUsage);

//       const instanceRecords = [];
//       for (let i = 0; i < perGeomCount; i++) {
//         const angle = Math.random() * Math.PI * 2;
//         const radius = Math.sqrt(innerR ** 2 + Math.random() * (outerR ** 2 - innerR ** 2));

//         const rec = {
//           index: i,
//           x: sunOffsetX + Math.cos(angle) * radius,
//           y: sunOffsetY + Math.sin(angle) * radius,
//           z: (Math.random() - 0.5) * 20,
//           scale: 20 + Math.random() * 40, // tune this — see note below
//           speed: (Math.random() - 0.5) * 0.2,
//           rot: new THREE.Euler(
//             Math.random() * Math.PI * 2,
//             Math.random() * Math.PI * 2,
//             Math.random() * Math.PI * 2
//           ),
//         };
//         instanceRecords.push(rec);

//         dummy.position.set(rec.x, rec.y, rec.z);
//         dummy.rotation.copy(rec.rot);
//         dummy.scale.setScalar(rec.scale);
//         dummy.updateMatrix();
//         instanced.setMatrixAt(i, dummy.matrix);
//       }
//       instanced.instanceMatrix.needsUpdate = true;

//       group.add(instanced);
//       records.push({ instanced, instanceRecords });
//     });

//     scene.add(group);

//     let frameId;
//     const clock = new THREE.Clock();
//     const animate = () => {
//       const dt = clock.getDelta();
//       records.forEach(({ instanced, instanceRecords }) => {
//         instanceRecords.forEach((rec) => {
//           rec.rot.x += rec.speed * dt;
//           rec.rot.y += rec.speed * 0.7 * dt;
//           dummy.position.set(rec.x, rec.y, rec.z);
//           dummy.rotation.copy(rec.rot);
//           dummy.scale.setScalar(rec.scale);
//           dummy.updateMatrix();
//           instanced.setMatrixAt(rec.index, dummy.matrix);
//         });
//         instanced.instanceMatrix.needsUpdate = true;
//       });
//       renderer.render(scene, camera);
//       frameId = requestAnimationFrame(animate);
//     };
//     animate();

//     rendererStateRef.current = { renderer, camera };

//     return () => {
//       cancelAnimationFrame(frameId);
//       records.forEach(({ instanced }) => {
//         instanced.material.dispose();
//         // Do NOT dispose instanced.geometry — it's the shared cached
//         // geometry from AddressableManager's cache map, reused elsewhere.
//       });
//       renderer.dispose();
//       rendererStateRef.current = {};
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [geometries, innerR, outerR, sunOffsetX, sunOffsetY, count]);

//   // Resize without rebuilding the belt
//   useEffect(() => {
//     const { renderer, camera } = rendererStateRef.current;
//     if (!renderer || !camera) return;
//     const { width, height } = containerSize;
//     renderer.setSize(width, height, false);
//     camera.left = -width / 2;
//     camera.right = width / 2;
//     camera.top = height / 2;
//     camera.bottom = -height / 2;
//     camera.updateProjectionMatrix();
//   }, [containerSize.width, containerSize.height]);

//   return (
//     <canvas
//       ref={canvasRef}
//       style={{
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         pointerEvents: 'none',
//         zIndex: 99999,
//         display: visible ? 'block' : 'none',
//       }}
//     />
//   );
// }


import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';

// const ASTEROID_COLORS = [0x6b6761, 0x77716a, 0x827b72, 0x91877b, 0x5f5c57, 0x756b61];

const ASTEROID_COLORS = [
//   "#292725",
//   "#4D5052",
//   "#7B7770",
//   "#C0B29E",
//   "#614d46",
//   "#f0e9e0", 
  "#6B6761",
  "#292826",
  "#827B72",
  "#a89c8b",
  "#5F5C57",
  "#726d6a",
];


export default function AsteroidBelt3D({
  geometries = [],
  innerR,
  outerR,
  sunOffsetX = 0,
  sunOffsetY = 0,
  containerSize,
  zoom = 1,
  pan = { x: 0, y: 0 },
  count = 50,
  visible = true,
}) {
  const canvasRef = useRef(null);
  const rendererStateRef = useRef({});
  const sizeRef = useRef(containerSize);
  sizeRef.current = containerSize;
  const MATRIX_UPDATE_INTERVAL = 4; // recompute every 4th frame (~15fps update rate for the rotation itself)
  let frameCounter = 0;


  useEffect(() => {
    if (!geometries.length) return;
    const canvas = canvasRef.current;
    const { width, height } = sizeRef.current;
    if (!width || !height) return;

    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(width, height, false);

    const scene = new THREE.Scene();

    const camera = new THREE.OrthographicCamera(
      -width / 2, width / 2, height / 2, -height / 2, 0.1, 2000
    );
    camera.position.set(0, 0, 500);
    camera.lookAt(0, 0, 0);

    scene.add(new THREE.AmbientLight(0xffffff, 0.45));
    const keyLight = new THREE.DirectionalLight(0xfff2d9, 1.1);
    keyLight.position.set(-300, 400, 600);
    scene.add(keyLight);

    const group = new THREE.Group();
    const perGeomCount = Math.max(1, Math.round(count / geometries.length));
    const dummy = new THREE.Object3D();
    const records = [];

    geometries.forEach(({ geometry }, gi) => {
      const material = new THREE.MeshStandardMaterial({
        color: ASTEROID_COLORS[gi % ASTEROID_COLORS.length],
        flatShading: true,
        roughness: 1,
        metalness: 0,
      });

      const instanced = new THREE.InstancedMesh(geometry, material, perGeomCount);
      instanced.instanceMatrix.setUsage(THREE.DynamicDrawUsage);

      const instanceRecords = [];
      for (let i = 0; i < perGeomCount; i++) {
        const angle = Math.random() * Math.PI * 2;
        const radius = Math.sqrt(innerR ** 2 + Math.random() * (outerR ** 2 - innerR ** 2));

        // Matches the sun-centering convention used everywhere else in the
        // app (planet positions, orbit paths): subtract sunOffsetX from X.
        // Y is additionally negated relative to that same convention
        // because Three.js is Y-up while the rest of the app is Y-down
        // (CSS/SVG screen space) — this is what makes an asteroid at a
        // given angle/radius land on the SAME screen pixel as a 2D
        // element would at that position, once the camera (below) is
        // also set up to match.
        const rec = {
          index: i,
          x: Math.cos(angle) * radius - sunOffsetX,
          y: Math.sin(angle) * radius - sunOffsetY,
          z: (Math.random() - 0.5) * 20,
          scale: 20 + Math.random() * 40,
          speed: (Math.random() - 0.5) * 0.2,
          rot: new THREE.Euler(
            Math.random() * Math.PI * 2,
            Math.random() * Math.PI * 2,
            Math.random() * Math.PI * 2
          ),
        };
        instanceRecords.push(rec);

        dummy.position.set(rec.x, rec.y, rec.z);
        dummy.rotation.copy(rec.rot);
        dummy.scale.setScalar(rec.scale);
        dummy.updateMatrix();
        instanced.setMatrixAt(i, dummy.matrix);
      }
      instanced.instanceMatrix.needsUpdate = true;

      group.add(instanced);
      records.push({ instanced, instanceRecords });
    });

    scene.add(group);

    let frameId;
    const clock = new THREE.Clock();
    const animate = () => {
      const dt = clock.getDelta();
      frameCounter++;

      if (frameCounter % MATRIX_UPDATE_INTERVAL === 0) {
        records.forEach(({ instanced, instanceRecords }) => {
          instanceRecords.forEach((rec) => {
            rec.rot.x += rec.speed * dt * MATRIX_UPDATE_INTERVAL; // compensate for skipped frames so speed still reads correctly
            rec.rot.y += rec.speed * 0.7 * dt * MATRIX_UPDATE_INTERVAL;
            dummy.position.set(rec.x, rec.y, rec.z);
            dummy.rotation.copy(rec.rot);
            dummy.scale.setScalar(rec.scale);
            dummy.updateMatrix();
            instanced.setMatrixAt(rec.index, dummy.matrix);
          });
          instanced.instanceMatrix.needsUpdate = true;
        });
      }

      renderer.render(scene, camera);
      frameId = requestAnimationFrame(animate);
    };
    animate();

    rendererStateRef.current = { renderer, camera };

    return () => {
      cancelAnimationFrame(frameId);
      records.forEach(({ instanced }) => {
        instanced.material.dispose();
      });
      renderer.dispose();
      rendererStateRef.current = {};
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geometries, innerR, outerR, sunOffsetX, sunOffsetY, count]);

  // Camera bounds driven by zoom/pan every frame those change.
  // left/right (X) needed no sign change — X isn't flipped between
  // Three.js and CSS space. top/bottom (Y) DOES need pan.y with the
  // opposite sign compared to a naive mirror of left/right, because of
  // the Y-up/Y-down mismatch described above. This was the actual bug:
  // previously top/bottom used the same "-pan.y" pattern as X's
  // "-pan.x", which is wrong for Y and is why the belt drifted away
  // from the rest of the scene during pan/zoom.
  useEffect(() => {
    const { renderer, camera } = rendererStateRef.current;
    if (!renderer || !camera) return;
    const { width, height } = containerSize;

    camera.left   = (-width / 2 - pan.x) / zoom;
    camera.right  = ( width / 2 - pan.x) / zoom;
    camera.top    = ( height / 2 + pan.y) / zoom;
    camera.bottom = (-height / 2 + pan.y) / zoom;
    camera.updateProjectionMatrix();
  }, [zoom, pan.x, pan.y, containerSize.width, containerSize.height]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 2,
        display: visible ? 'block' : 'none',
      }}
    />
  );
}